import React , {useState,useEffect ,useContext,useRef,useCallback} from 'react'
import { DeviceContext } from '../photosMain';
import { Link ,useNavigate,useLocation} from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import '../../../styles/photosPages.css'
import Skeleton from '../skelton';
import PageAds from '../../common/pageAds';

const PhotosPages = ({data:ssrPages}) => {

                      const ssr = ssrPages?.[0]?.pagesData || {}
                      const {mobile,setMobile,containerRef} = useContext(DeviceContext)
                      const d = ssr || {};
                      const ssrData = ssr?.catData;
                      const ssrAlphabet = ssr?.alphabet
                      const ssrDataError = ssr?.catDataError;
                    
                      const navigate = useNavigate();
                      const location = useLocation();
                      const path = location.pathname;

                      const slug = path.substring(path.lastIndexOf('/') + 1, path.lastIndexOf('.html'));
                    const parts = slug.split('-');

                    let sectionId = null;
                    let urlAlphabet = null;

                    if (parts.length === 2) {
                      // actors-2
                      sectionId = parts[1];
                    } else if (parts.length === 3) {
                      // actors-66-2
                      const alphabetId = parseInt(parts[1]);
                      sectionId = parts[2];
                      urlAlphabet = String.fromCharCode(alphabetId);
                    }



                   let cat = "";

                  switch (true) {
                    case path.includes("/actors"):
                      cat = "Actors";
                      break;
                    case path.includes("/actress"):
                      cat = "Actress";
                      break;
                    case path.includes("/events"):
                      cat = "Events";
                      break;
                    case path.includes("/kingsize"):
                      cat = "KingSize";
                      break;
                    case path.includes("/movies"):
                      cat = "Movies";
                      break;
                    case path.includes("/others"):
                      cat = "Others";
                      break;
                    case path.includes("/wallpapers"):
                      cat = "WallPapers";
                      break;
                    default:
                      cat = "No Cat";
                  }

     

                      const breadCrumbAddress = path.substring(path.lastIndexOf('/') + 1, path.lastIndexOf('-'));
                    
                      const [data, setData] = useState(ssrData || []);
                      const [error, setError] = useState(ssrDataError || null);
                      const [hasMore, setHasMore] = useState(true);
                      const [initialLoading, setInitialLoading] = useState(!ssrData);
                      const [loadingMore, setLoadingMore] = useState(false);
                      const [hydrating, setHydrating] = useState(true);
                      const [selectedAlphabet, setSelectedAlphabet] = useState(ssrAlphabet || urlAlphabet || null);
                      const [page, setPage] = useState(0);
                    
                      const loadRef = useRef();
                      const observerRef = useRef();
                      const currentPage = useRef(-1);
                      const currentSectionRef = useRef(sectionId);
                      const currentAlphabetRef = useRef(ssrAlphabet);
                      const contentWrapperRef = useRef(null);
                      const isFirstFetchDone = useRef(false);
                    
                      const handleClick = (url) => {
                        navigate(url.substring(url.indexOf('/photos') + 7));
                      };
                    
                  
                  
                     useEffect(()  =>   {
                     
                         
                        const hydrationTimer = setTimeout(() => {
                              
                                 setHydrating(false)
                    
                           },300);
                    
                    
                           return () => clearTimeout(hydrationTimer);
                    
                       },[])
                  
                  
                  
                  
                  
                  
                  
                  
                  
                  
                  
                  
                      const fetchData = useCallback(

                        


                        async (pageToLoad, section = sectionId, alphabet = selectedAlphabet) => {
                          if (pageToLoad === currentPage.current) return;
                         

                          if (pageToLoad === 0) {
                                setInitialLoading(true);
                              } else {
                                setLoadingMore(true);
                              }
                          currentPage.current = pageToLoad;
                          currentSectionRef.current = section;
                          currentAlphabetRef.current = alphabet;
                         
                    
                          const alphabetParam = alphabet ? `&srh=${alphabet}` : '';
                          const limit = window.innerWidth > 600 ? 12 : 6;
                    
                          try {
                            const response = await fetch(
                              `https://www.teluguone.com/photos_api/photosLatestByTypeJson?galTypeId=${section}&start=${
                                pageToLoad * limit
                              }&limit=${limit}${alphabetParam}`
                            );
                    
                            if (!response.ok) throw new Error('Failed to fetch');
                    
                            const newData = await response.json();
                          const validItems = newData.photosHomeByType.filter((item) => !item.msg);
                    
                            if (validItems.length > 0) {
                              setData((prev) => (pageToLoad === 0 ? validItems : [...prev, ...validItems]));
                              setHasMore(true);
                            } else {
                              if (pageToLoad === 0) setData([]);
                              setHasMore(false);
                            }
                            if (pageToLoad === 0) {
                                isFirstFetchDone.current = true;
                                 }
                          } catch (err) {
                            setError(err.message);
                          
                          } finally {
                            if (pageToLoad === 0) {
                                  setInitialLoading(false);
                                } else {
                                  setLoadingMore(false);
                                }
                          }
                        }, [sectionId, selectedAlphabet])
                    
                    
                    useEffect(() => {
                      if (!hasMore || initialLoading || page !== 0) return;
                    
                      const checkIfContentTooShort = () => {
                        const contentHeight = contentWrapperRef.current?.offsetHeight || 0;
                        const viewportHeight = window.innerHeight;
                    
                       
                       if (contentHeight < viewportHeight && data.length > 0) {
                          setPage(1); 
                       }
                      };
                    
                      const timeout = setTimeout(checkIfContentTooShort, 100);
                      return () => clearTimeout(timeout);
                    }, [data, hasMore, initialLoading, page]);
                    
                    
                    
                    
                    
                      const resetAndFetch = (newSectionId = sectionId, alphabet = null) => {
                        if (observerRef.current) observerRef.current.disconnect(); 
                    
                        currentPage.current = -1;
                        currentSectionRef.current = newSectionId;
                        currentAlphabetRef.current = alphabet;
                    
                        setData([]);
                        setError(null);
                        setHasMore(true);
                        setSelectedAlphabet(alphabet);
                        setPage(0); 
                      };

                      // Reset when sectionId changes
                     useEffect(() => {
                        if (
                          currentSectionRef.current !== sectionId ||
                          currentAlphabetRef.current !== urlAlphabet
                        ) {
                          resetAndFetch(sectionId, urlAlphabet);
                        }
                      }, [sectionId, urlAlphabet]);


                    
                      // SSR fallback if no data
                      useEffect(() => {
                        if (!ssrData && currentPage.current === -1) {
                          resetAndFetch(sectionId, null);
                        }
                      }, [ssrData, sectionId]);
                    
                      // Fetch when page changes
                      useEffect(() => {
                        fetchData(page, currentSectionRef.current, currentAlphabetRef.current);
                      }, [page, fetchData]);
                    
                      // IntersectionObserver logic
                  useEffect(() => {
                      if (!hasMore || loadingMore || !loadRef.current) return;
                      if (!isFirstFetchDone.current) return; 

                      if (observerRef.current) observerRef.current.disconnect();

                      observerRef.current = new IntersectionObserver((entries) => {
                        if (entries[0].isIntersecting) {
                          setPage((prev) => prev + 1);
                        }
                      });

                      observerRef.current.observe(loadRef.current);

                      return () => observerRef.current?.disconnect();
                    }, [hasMore, loadingMore]);

  
const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

  return (

  <main className="photos-pages">

     <Helmet><title>{cat} Photos, HD Images & Gallery | TeluguOne</title></Helmet>
       
            <div className="alpha-filter">
  
  <div className="breadcrumb">
  <Link to="/">Home</Link> / <span>{cat}</span>
  
</div>

<div className="alphabet-links">
  {alphabets.map((letter, i) => (
    <span key={letter}>
      <button type='button' onClick={() => {
  const alphabetId = letter.charCodeAt(0);
  navigate(`/pages/${path.substring(path.lastIndexOf("/"),path.indexOf("-") )}-${alphabetId}-${sectionId}.html`);
}}
 className={selectedAlphabet === letter ? "alpha-active" : ""}
>
        {letter}
      </button>
      {i !== alphabets.length - 1 && " | "}
    </span>
  ))}
</div>


 </div> 



 <div className="vpb-datas">

      {(initialLoading || hydrating) &&  [0,0,0,0,0,0,0,0].map((item,index) => <Link key={index}   to="" className="card">
                   <Skeleton type={"vps-datas-img"} />
                   <div className="card-overlay" ><span>Loading..</span></div>
      </Link>)   }

      {Array.isArray(data)  &&
            data.map((image, index) => (<Link key={index} to={(image.url_link  ? image.url_link.substring(image.url_link.indexOf('/photos')+7) :""  )} className={`card ${hydrating ? 'd-none' : ''}`}>
    <img loading={index === 0 ? 'eager' : 'lazy'}
                    fetchpriority={index === 0 ? 'high' : 'low'}
                    src={image.stimg || '/photos/assets/images/error_img.webp'}
                    alt={image.title || 'Photo'} />
    <div className="card-overlay" ><span>{image.title || 'Photo'}</span></div>
      </Link>))}
      
    {error && <p style={{width:"100%",textAlign:"center",fontWeight:"bold",color:"black"}}>No Json Data</p>}

     </div>
    
    <div className='vpb-datas' style={{height:"200px"}} >
          
          {hasMore && !loadingMore && data && data.length > 4 && 
             <p ref={loadRef} style={{textAlign:"center",color:"black",width:"100%",padding:"30px 0",fontWeight:"bold"}}>Loading..</p>
          }
           
                  {!hasMore && data.length === 0 && !loadingMore && (
                 <div className="row"  style={{width:"100%",margin:"10px"}}>
                  <p style={{textAlign:"center",color:"black",width:"100%",padding:"30px 0",fontWeight:"bold"}}  >No Data Found</p>
                </div>
               )}

               {!hasMore && data.length > 0 && (
                 <div className="row" style={{width:"100%",margin:"10px"}}>
                <p  style={{textAlign:"center",color:"black",width:"100%",padding:"30px 0",fontWeight:"bold"}}>No More Data</p>
                 </div>
              )}

    </div>

 <PageAds  mobile={mobile} containerRef={containerRef} />
  </main>

  
  
   


      
  
  )
}

export default PhotosPages;


